import { ReactComponent as Logo } from "assets/svg/logo.svg";
import {
  AppBar,
  Button, CircularProgress,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import ShoppingBagOutlined from "@mui/icons-material/ShoppingBagOutlined";
import AccountCircle from "@mui/icons-material/AccountCircle";
import PersonIcon from "@mui/icons-material/Person";
import { Box } from "@mui/system";
import ShoppingBag from "components/ShoppingBag";
import { useState, MouseEvent } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Colors } from "helpers/Consts";
import MenuNavBar from "components/MenuNavBar";
import { ICardapioAppState } from "../../redux/RootReducer";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";
import { IPlaceData } from "../../types/Place";

type Props = {
  shoppingBagQuery: UseQueryResult<IShoppingBagData>,
  placeInfo: IPlaceData | undefined
}

function NavBar({shoppingBagQuery, placeInfo}: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const { search} = useLocation()
  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);
  const {data: shoppingBag, isLoading, isRefetching} = shoppingBagQuery

  const toggleDrawer = () => {
    //console.log("toggleDrawer");
    setOpen(!open);
  };
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleClickMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const placeEstaFechado = placeInfo?.closed ?? true

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{ zIndex: "1300", display: { xs: "none", md: "flex" } }}
    >
      <Toolbar>
        <Box
          component={Link}
          to={`/${search}`}
          sx={{
            textDecoration: "none",
          }}
        >
          <Logo fill="primary" height={"60"} width={"60"} />
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Box>
          {loginInfo && loginInfo.id ? (
            <Tooltip title="Configurações">
              <IconButton
                size="large"
                color="primary"
                aria-label="menu"
                onClick={handleClickMenu}
                sx={{ ml: 2, paddingTop: 1 }}
              >
                <PersonIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Box
              component={Link}
              to={`/login${search}`}
              sx={{
                textDecoration: "none",
              }}
            >
              <Button
                color="primary"
                variant="outlined"
                startIcon={<AccountCircle />}
              >
                Fazer Login
              </Button>
            </Box>
          )}
          {loginInfo && loginInfo.id && (
            <>
              <IconButton
                size="large"
                color="primary"
                aria-label="menu"
                sx={{ ml: 2, paddingTop: 1 }}
                onClick={() => {
                  toggleDrawer();
                }}
              >
                <ShoppingBagOutlined />

                {(isLoading || isRefetching) && (
                  <Box sx={{minWidth:'25px'}}>
                    <CircularProgress size={20} thickness={5} />
                  </Box>)}

                {placeEstaFechado &&
                  (<Box>
                    <Typography
                      color={Colors.baseTextColor}
                      lineHeight={"12px"}
                      fontWeight={700}
                      fontSize={"13px"}
                    >-</Typography>
                </Box>)}

                {!placeEstaFechado && !(isLoading || isRefetching) &&
                <Box>
                  <Typography
                    color={Colors.baseTextColor}
                    lineHeight={"12px"}
                    fontWeight={700}
                    fontSize={"13px"}
                  >
                    {shoppingBag
                      ? shoppingBag?.total.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "0,00 R$"}
                  </Typography>
                  <Typography
                    color={Colors.baseTextColor}
                    lineHeight={"12px"}
                    fontWeight={700}
                    fontSize={"13px"}
                  >
                    {shoppingBag
                      ? shoppingBag?.items && shoppingBag.items.length
                      : 0}{" "}
                    itens
                  </Typography>
                </Box>}
              </IconButton>
              <ShoppingBag open={open} toggleDrawer={toggleDrawer} shoppingBagQuery={shoppingBagQuery} />
            </>
          )}
        </Box>
      </Toolbar>
      <MenuNavBar
        anchorEl={anchorEl}
        handleClose={handleCloseMenu}
        open={openMenu}
        name={loginInfo?.name}
      />
    </AppBar>
  );
}

export default NavBar;
